var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvertedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M6.846 8.532c.385.168.553.636.351.99-.43.812-.648 1.674-.648 2.567 0 3.142 2.696 5.693 6.024 5.693.168 0 .312-.008.51-.028l-1.53-1.446c-.322-.278-.322-.75-.006-1.049.289-.274.77-.274 1.087 0l2.896 2.739c.145.137.23.328.23.52 0 .194-.085.384-.23.522L12.64 21.77c-.29.303-.782.303-1.087.014-.323-.278-.323-.75-.007-1.049l1.582-1.497c-.177.012-.362.017-.556.017C8.396 19.256 5 16.038 5 12.089c0-1.136.277-2.22.817-3.221.178-.365.666-.521 1.029-.336zm6.607-6.346c.146.137.231.328.231.52 0 .194-.085.385-.23.522L11.87 4.724c.177-.01.362-.016.556-.016 4.177 0 7.573 3.218 7.573 7.167 0 1.14-.28 2.244-.817 3.241-.178.364-.666.521-1.029.336-.385-.168-.553-.636-.351-.99.43-.813.648-1.675.648-2.567 0-3.143-2.696-5.693-6.024-5.693-.168 0-.312.008-.51.028l1.53 1.446c.322.277.322.75.013 1.042-.29.302-.781.302-1.094.007L9.477 5.993c-.322-.278-.322-.75-.006-1.05l2.895-2.718c.301-.285.78-.3 1.087-.04z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertedIcon);
export default __webpack_public_path__ + "static/media/converted-icon.0d4117d1.svg";
export { ForwardRef as ReactComponent };